var _defs, _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.024,18.528c.014-.107.144-.493.191-.626.759-2.144,3.256-3.144,5.264-1.983l6.91-5.083c.216-.212-.024-.476-.062-.709-.237-1.462.112-2.776,1.31-3.712,2.627-2.051,6.344.192,5.893,3.423l5.346,2.583c1.179-1.849,3.403-2.48,5.301-1.25.208.135.469.5.676.45l5.993-3.628c-1.197-3.717,3.573-6.496,6.198-3.596,2.508,2.77-.317,7.097-3.823,5.973-.352-.113-.675-.474-1.044-.282l-6.294,3.756c-.104.118-.157,1.032-.231,1.315-.962,3.704-6.281,3.494-7.122-.162l-6.088-2.997c-1.239,1.094-2.85,1.218-4.334.556l-6.828,5.111c-.275.256.018.651.044.991.392,5.104-6.742,5.338-7.298.987-.032-.254-.032-.863,0-1.117Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 38.689,
    y: 17.755,
    width: 7.303,
    height: 27.054,
    rx: 1.735,
    ry: 1.735
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 26.496,
    y: 25.213,
    width: 7.303,
    height: 19.597,
    rx: 1.476,
    ry: 1.476
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 14.303,
    y: 20.503,
    width: 7.303,
    height: 24.306,
    rx: 1.644,
    ry: 1.644
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 2.11,
    y: 30.237,
    width: 7.303,
    height: 14.572,
    rx: 1.273,
    ry: 1.273
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics);
export default __webpack_public_path__ + "static/media/icon-analytics.90fa91dc0a1ded65022208d456cbfa6b.svg";
export { ForwardRef as ReactComponent };